import React from 'react';
import { DataTableRenderCellParams, InputTable } from '@/components/custom/erp';
import InputTableActionBar from './InputTableActionBar';
import { getInvoiceCollectionColumns } from './cols';

import { SelectedCellInfo } from '@/features/danh-muc/hop-dong-khe-uoc/khe-uoc/hooks/useThongTinLaiSuat';
import { ChiTietKheUocLaiSuat } from '@/types/schemas';

interface ThongTinLaiSuatProps {
  mode: 'add' | 'edit' | 'view';
  rows: ChiTietKheUocLaiSuat[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: (params: { id: string; row: ChiTietKheUocLaiSuat }) => void;
  onCellClick?: (params: DataTableRenderCellParams<ChiTietKheUocLaiSuat>) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (
    rowUuid: string,
    field: keyof ChiTietKheUocLaiSuat,
    newValue: ChiTietKheUocLaiSuat[keyof ChiTietKheUocLaiSuat]
  ) => void;
}

const ThongTinLaiSuatTab: React.FC<ThongTinLaiSuatProps> = ({
  mode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onCellValueChange
}) => {
  return (
    <InputTable
      rows={rows}
      className='h-96'
      onRowClick={onRowClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={getInvoiceCollectionColumns(onCellValueChange)}
      getRowId={row => row?.uuid || ''}
      actionButtons={
        <InputTableActionBar
          mode={mode}
          handleAddRow={onAddRow}
          handleDeleteRow={onDeleteRow}
          handleCopyRow={onCopyRow}
          handlePasteRow={onPasteRow}
          handleMoveRow={onMoveRow}
        />
      }
    />
  );
};

export default ThongTinLaiSuatTab;
